import { MyInventoryResponseType } from "magic-shared-types";
import { api } from "../api";

export const cardtraderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMyInventory: builder.query<MyInventoryResponseType[], { token: string }>(
      {
        query: ({ token }) => ({
          url: "https://api.cardtrader.com/api/v2/products/export",
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
      }
    ),
  }),
});

export const { useGetMyInventoryQuery } = cardtraderApi;
